/**
 * Dependencies.
 */
import { BaseModel, endpoint, prop, required } from '@prz-dp/services';

/**
 * Export `ServicePointOrderDeliverModel`.
 */
@endpoint('servicePointOrder/{trackingNumberKey}/deliver')
export class ServicePointOrderDeliverModel extends BaseModel {
  /**
   * Properties.
   */
  @required()
  deliveredTo: string;

  @prop()
  images: {
    encodedFileContent: string;

    fileName?: string;

    mediaType: string;

    type: string;
  }[];

  @prop({ defaultValue: null })
  notes: string;

  @prop()
  orderPackages: {
    packageCode: string;

    status: string;
  }[];

  @required()
  reasonCode: string;

  @prop({ defaultValue: 5 })
  satisfaction: number;

  @required()
  trackingNumberKey: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<ServicePointOrderDeliverModel>) {
    super(data);
  }
}
